import { useContext, useEffect, useState } from 'react';
import { getCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleTextInput from '../../components/ModuleTextInput';
import { changeStringFieldValue, changeValue_noType } from '../../ModuleList';
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";
import { filesRoute } from "../../../../../../../api/routes";
import config from "../../../../../../../config";
import { CUSTOMISED_URL_MAP } from "../../../../../../../config/FeatureDashboardVarMap";

import ImageIcon from '../../../../WorkspaceAssets/ListIcons/image-icon.png';

import './VideoField.scss';
import { PANEL_CONTENT_TYPES, slideOutPanelControl } from '../../../../../../../containers/TimelineEditor/slideout-panel/SlideoutPanel';
import { WORKING_ON_NODE_DATA } from '../../../EditablePreview/VisualisedComponents/VisualisedNode';
import { convertUniqueFilenameToOriginal } from '../../../../v2IntegrationHelpers/CampaignAndFeatureDataHelperFunctions';

const VideoField = (props) => {
    const fieldData = props.fieldData;
    const customisationVars = props.customisationVars;

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    const [videoFileData, setVideoFileData] = useState(props.value);
        /* useEffect(() => {
            setVideoFileData(props.value);
        }, [customisationVars, fieldData, props.index, props.visualisationComponentKey, props.selectedFeatureNode, props.value]); */


    useEffect(() => {
        const rawData_loc = getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
        setVideoFileData(null);
        setTimeout(() => {
            setVideoFileData(rawData_loc);
        }, 10);
    }, [customisationVars, fieldData, props.index, props.visualisationComponentKey, props.selectedFeatureNode, campaignContext]);

    const updateReceived = (updatedAudioFileData) => {
        // setUpdateCounter((prevVal) => prevVal + 1);
        // Make a copy of this data to avoid mutating props
        const updatedValCopy = Object.assign({}, updatedAudioFileData);
        changeValue_noType(
            customisationVars,
            fieldData?.customFieldConfig,
            updatedValCopy,
            props.index ?? 0,
            props.visualisationComponentKey ?? null,
            props.selectedFeatureNode,
            true,
            false
        );
        setVideoFileData(updatedValCopy);
    };

    const fileChangeClickHandler = () => {
        slideOutPanelControl.openVideoUploader(
            Object.assign({}, videoFileData),
            (updatedVideoFileData) => { console.log('VideoField: Video file changed callback'); updateReceived(updatedVideoFileData); },
            (updatedVideoFileData) => { console.log('VideoField: Video file change confirmed, prob not needed for this one...'); },
            'Upload Video',
            fieldData?.customFieldConfig
        );
    }

    useEffect(() => {
        console.log('VideoField: Detected videoFileData change, checking if video uploader panel is open for this field...', slideOutPanelControl, fieldData);
        if (slideOutPanelControl.panelState.isOpen && slideOutPanelControl.panelState.type === PANEL_CONTENT_TYPES.VIDEO_UPLOADER && slideOutPanelControl.panelState.fieldData?.dataLink === fieldData?.customFieldConfig?.dataLink) {
            // If the video uploader panel is open for this field, refresh it with the new data
            console.log('VideoField: Detected videoFileData change while video uploader panel is open, refreshing panel with new data:', videoFileData);
            // Trigger video uploader slide out panel
            fileChangeClickHandler();
        }
    }, [videoFileData]);

    return (
        <>
            <div className={`v2-module-field-label${!props.isEnabled ? ' disabled' : ''}`}>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Image'}</div>
            <ModuleTextInput
                fieldLabel={<div className="v2-module-block-field-input-label" style={{backgroundColor: '#FFFFFF', backgroundImage: `url(${ImageIcon})`, backgroundSize: '1.8rem', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}} />}
                value={typeof videoFileData === 'string' ? videoFileData : convertUniqueFilenameToOriginal(videoFileData?.filename ?? '') ?? '<No Video Selected>'}
                fieldId={'video-file'}
                enabled={props.isEnabled}
                editable={false}
                onChange={null}
                onClick={
                    props.isEnabled ? fileChangeClickHandler : null
                }
            />
            {videoFileData?.srcUrl &&
                <div className={`video-preview-holder${!props.isEnabled ? ' v2-module-disabled-field' : ''}`}>
                    <video width={198} height={110} controls>
                        <source src={videoFileData?.srcUrl} />
                    </video>
                </div>
            }
            <div className='pill-button' onClick={props.isEnabled ? fileChangeClickHandler : null}>Replace Video</div>
        </>
    );
};

export default VideoField;
